import { ProductColor } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { Td as PDFTd } from '../../components/pdf-export/Td/Td.js';
import { Td as WebTd } from '../../components/table.js';
import { useIsPDF } from '../internal/useIsPDF.js';

type Props = PropsWithChildren<{
  width?: string;
  textAlign?: 'right' | 'left';
  colSpan?: number;
  border?: string;
  isFirstRow?: boolean;
  isFirstColumn?: boolean;
  rowSpan?: number;
  backgroundColor?: ProductColor;
  height?: string;

  /** @deprecated this doesn't make sense on Td and might go away */
  justifyContent?: 'flex-end';
}>;

export function Td(props: Props) {
  const { children, ...rest } = props;
  return useIsPDF() ? <PDFTd {...rest}>{children}</PDFTd> : <WebTd {...rest}>{children}</WebTd>;
}
